<template>
    <modal
        name="course-video-exception-error"
        width="90%"
        :maxWidth="800"
        height="auto"
        :adaptive="true"
        :scrollable="true"
        :clickToClose="false"
    >
        <div class="course-video-exception-modal">
            <template v-if="getNonLoggedException">
                <h1 class="course-video-exception-modal__title" v-html="$t('CourseVideo.modal_log_out_error')"></h1>
                <TotemButton
                    color="secondary"
                    @click="logout"
                    class="course-video-exception-modal__button"
                    :label="$t('General.close')"
                />
            </template>
            <template v-else>
                <h1 class="course-video-exception-modal__title" v-html="$t('CourseVideo.modal_exception_error')"></h1>
                <TotemButton
                    color="secondary"
                    @click="refreshPage"
                    class="course-video-exception-modal__button"
                    :label="$t('General.close')"
                />
            </template>
        </div>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ModalCourseVideoExceptionError',
        computed: {
            ...mapGetters({
                getNonLoggedException: 'VideoLog/getNonLoggedException'
            }),
        },
        methods: {
            logout () {
                this.$modal.hide('course-video-exception-error')
                this.$store.dispatch('logout')
            },
            refreshPage () {
                this.$modal.hide('course-video-exception-error')
                this.$store.dispatch('VideoLog/resetErrorException')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-video-exception-modal {
        padding: 40px;
        width: 100%;
        display: flex;
        flex-direction: column;

        [class*="desktop"] & {
            padding: 70px;
        }

        &__title {
            text-align: center;
            font-size: 1.8rem;
            line-height: 3rem;
            font-weight: 500;
            font-family: QuickSand-Regular, sans-serif;

            [class*="desktop"] & {
                font-size: 2.2rem;
                line-height: 3.6rem;
            }

            & > span {
                display: block;
                margin-bottom: 20px;
            }
        }

        &__button {
            align-self: center;
            margin: 30px 0 0 0;
        }
    }
</style>
